import React from 'react'
import { useState, useEffect, useContext, useMemo, useCallback, useRef } from 'react';
import { useParams, useLocation } from "react-router-dom";
 
import cogoToast from "cogo-toast";
import { FaCheckCircle, FaExclamationCircle, FaPrint, FaSearch, FaTimesCircle, FaEye } from "react-icons/fa";
import * as SurveyCore from "survey-core";
import { Survey } from 'survey-react-ui';
import { getList, genericPost, genericGet } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS } from "../../../Constants";
import AppContext from "../../../AppContext";
import { getListStaffDetailsRequestBody, getLoggedInStaffAccountId } from "../../../services/Utils";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, Spinner, FormGroup } from "reactstrap";

 
  import "react-multi-date-picker-calendar/dist/calendar.css";
import { Badge } from 'react-bootstrap';

const PENDING_STATUS = 10000;

const parseToilDates = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const isCurrentUserApprover = (approverStaff, user) => {
  const approverId = approverStaff?.id;
  if (!approverId || !user) return false;
  return (
    String(approverId) === String(user.staff_account_id) ||
    String(approverId) === String(user.id)
  );
};

const getStaffObject = (record, prefix, level) => {
  const objectKeys = [
    `${prefix}_approver_${level}_staff`,
    `${prefix}_approver_${level}_user`,
    `${prefix}_approver_${level}`,
  ];
  for (const key of objectKeys) {
    const value = record?.[key];
    if (value && typeof value === "object" && !Array.isArray(value)) {
      return value;
    }
  }
  return null;
};

const getApproverId = (record, prefix, level) => {
  const staff = getStaffObject(record, prefix, level);
  if (staff?.id != null) return staff.id;
  const raw = record?.[`${prefix}_approver_${level}`];
  if (raw != null && typeof raw !== "object") return raw;
  return null;
};

const buildApproverInfo = (record, prefix, level, users = []) => {
  const staff = getStaffObject(record, prefix, level);
  const approverId = getApproverId(record, prefix, level);
  const userFromList = approverId
    ? users.find((user) =>
        [user.id, user.value, user.staff_account_id, user.user_id].some(
          (candidate) => candidate != null && String(candidate) === String(approverId)
        )
      )
    : null;

  const source = staff || userFromList || {};
  const name =
    source.staff_name ||
    source.name ||
    source.text ||
    source.display_name ||
    source.label ||
    "";
  const role = source.role || source.role_name || source.designation || "";

  return {
    level,
    id: staff?.id ?? userFromList?.id ?? userFromList?.value ?? approverId,
    name,
    role,
    staffId: source.staff_id || source.staff_code || "",
    email: source.email || "",
    status: record?.[`${prefix}_approver_${level}_status`],
    remarks:
      record?.[`${prefix}_approver_${level}_remarks`] ||
      record?.[`${prefix}_approver_${level}_comments`] ||
      record?.[`${prefix}_approver_${level}_comment`] ||
      "",
    actedOn:
      record?.[`${prefix}_approver_${level}_date`] ||
      record?.[`${prefix}_approver_${level}_acted_on`] ||
      record?.[`${prefix}_approver_${level}_approved_at`] ||
      "",
  };
};

const formatDisplayValue = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  return value;
};

const renderApprovalStatus = (status) => {
  if (status == 10000) {
    return (
      <span>
        <FaExclamationCircle style={{ color: "grey" }} /> Pending
      </span>
    );
  }
  if (status == 10002) {
    return (
      <span>
        <FaTimesCircle style={{ color: "red" }} /> Rejected
      </span>
    );
  }
  if (status == 10001) {
    return (
      <div>
        <FaCheckCircle style={{ color: "green" }} /> Approved
      </div>
    );
  }
  return "—";
};
const ToilDetails = () => {
  const { id: toilIdFromUrl } = useParams();
  const location = useLocation();
  const global = useContext(AppContext);
  const currentUser = global.get_logged_in_user();

  const [toilData, setToilData] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [isSubmittingApproval, setIsSubmittingApproval] = useState(false);
  const [approvalModalDismissed, setApprovalModalDismissed] = useState(false);
  const hasAutoOpenedApprovalModal = useRef(false);
  const currentUserStaffAccountId = getLoggedInStaffAccountId(currentUser);
  const currentUserId = currentUser?.id;
    const [selectedDates, setSelectedDates] = useState([]);
    const [leave_type, setLeave_type] = useState(null)
    const [leave_types, setLeave_types] = useState([]);
const [staff_code, setstaff_code] = useState("")
const [staff_data, setstaff_data] = useState(null)
const [users, setUsers] = useState([])
const [approvalComments, setapprovalComments] = useState("")
const [supervisor, setSupervisor] = useState(null)
const [hr_staff, setHr_staff] = useState(null)
const [claimSubmitted, setClaimSubmitted] = useState(false);

const data = toilData;
const toilDates = useMemo(() => parseToilDates(data?.toil_dates), [data?.toil_dates]);

const requestApprovers = useMemo(
  () => (data ? [1, 2].map((level) => buildApproverInfo(data, "request", level, users)) : []),
  [data, users]
);

const pendingApprovalLevel = useMemo(() => {
  if (!currentUser) return null;
  const pending = requestApprovers.find(
    (approver) =>
      approver.status == PENDING_STATUS && isCurrentUserApprover({ id: approver.id }, currentUser)
  );
  return pending?.level ?? null;
}, [requestApprovers, currentUserStaffAccountId, currentUserId]);

const fetchToilDetails = useCallback((toilId) => {
  if (!toilId) return;
  setIsLoadingDetails(true);
  genericGet(`${ENDPOINTS.TOIL_DETAILS}/${toilId}`)
    .then((res) => {
      setIsLoadingDetails(false);
      if (res?.status === 200 && res?.data?.status === SUCCESS_RESULT) {
        setToilData(res.data.data);
      } else {
        cogoToast.error(res?.data?.message || "Failed to load TOIL request.");
        setToilData(null);
      }
    })
    .catch(() => {
      setIsLoadingDetails(false);
      cogoToast.error("Failed to load TOIL request.");
      setToilData(null);
    });
}, []);

useEffect(() => {
  const stateData = location.state?.data;
  if (stateData && (!toilIdFromUrl || String(stateData.id) === String(toilIdFromUrl))) {
    setToilData(stateData);
    return;
  }
  if (toilIdFromUrl) {
    fetchToilDetails(toilIdFromUrl);
  } else if (!stateData) {
    cogoToast.error("TOIL request not found. Open a request from the list or use a valid link.");
  }
}, [toilIdFromUrl, location.state, fetchToilDetails]);

useEffect(() => {
  setApprovalModalDismissed(false);
  hasAutoOpenedApprovalModal.current = false;
}, [toilIdFromUrl]);

useEffect(() => {
  if (!toilIdFromUrl || !pendingApprovalLevel || approvalModalDismissed) return;
  if (hasAutoOpenedApprovalModal.current) return;
  hasAutoOpenedApprovalModal.current = true;
  setShowApprovalModal(true);
}, [toilIdFromUrl, pendingApprovalLevel, approvalModalDismissed]);

const convert_date = (m) => {
  var date = new Date(m);
  var year = date.getFullYear();
  var month = ("0" + (date.getMonth() + 1)).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);

  let formatted = `${year}-${month}-${day}`;
  return formatted;
};

useEffect(() => {
  listLeaveTypes();
  listUsers();
  const staffRequest = getListStaffDetailsRequestBody(currentUser);
  if (staffRequest) {
    load_staff_details(staffRequest);
  }
}, [currentUser]);

const survey_Model = useMemo(() => {
  const template = {
    ...(data?.claim_template || {}),
    showCompletePage: false,
    completedHtml: "",
  };
  const model = new SurveyCore.Model(template);
  model.showCompletePage = false;
  model.completedHtml = "";
  return model;
}, [data?.claim_template]);
const listUsers =async ()=>{
  setIsLoading(true);
  setUsers( await getList(ENDPOINTS.LIST_USERS))
  setIsLoading(false);
} 
const claimToilRequest = (sender) => {
  const result = sender.data;

  const payload = {
    toil_id: data?.id,
    claim_data: result,
    claim_approver_1: result?.claim_approver_1,
    claim_approver_2: result?.claim_approver_2,
  };

  setIsLoading(true);

  genericPost(ENDPOINTS.CLAIM_TOIL_REQUEST, payload)
    .then((response) => {
      setIsLoading(false);
      if (response.status == 200) {
        if (response.data.status == SUCCESS_RESULT) {
          setClaimSubmitted(true);
          sender.mode = "display";
          cogoToast.success(response.data.message, {
            hideAfter: 5,
          });
        } else {
          cogoToast.error(response.data.message, {
            hideAfter: 5,
          });
        }
      }
    })
    .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please Try again. " + err, {
        hideAfter: 5,
      });
    });
};

const load_staff_details = (requestBody) => {
  if (!requestBody || (!requestBody.staff_code && !requestBody.staff_id)) {
    return;
  }

  setIsLoading(true);
  genericPost(ENDPOINTS.LIST_STAFF_DETAILS, requestBody)
    .then((res) => {
      if (res.status == 200) {
        if (res.data.status == SUCCESS_RESULT) {
          setstaff_data(res.data["data"]);
       
        } else {
          cogoToast.error(res.data.message, {});
        }
      } else {
        cogoToast.error("Connection error. Please try again.", {});
      }
      setIsLoading(false);
    })
    .catch((err) => {
      setIsLoading(false);
      cogoToast.error("Critical error occurred. Please try again.", {});
    });
};

const find_staff_by_code = (staff_id) => {
  if (!staff_id) {
    return;
  }

  load_staff_details({ staff_code: String(staff_id).trim() });
};

const approve_toil = (level, status, remarks, skipConfirm = false) => {
  const actionLabel = status === 10001 ? "Approve" : "Reject";
  if (!skipConfirm && !window.confirm(`Are you sure you want to ${actionLabel} this TOIL request?`)) {
    return;
  }

  const payload = {
    toil_id: data?.id,
    action: level,
    status,
    remarks,
  };

  setIsSubmittingApproval(true);
  setIsLoading(true);

  genericPost(ENDPOINTS.APPROVE_TOIL, payload)
    .then((res) => {
      setIsLoading(false);
      setIsSubmittingApproval(false);
      if (res.status == 200) {
        const responseData = res.data;
        if (res.data.status == SUCCESS_RESULT) {
          cogoToast.success(responseData.message);
          setShowApprovalModal(false);
          setapprovalComments("");
          if (toilIdFromUrl) {
            fetchToilDetails(toilIdFromUrl);
          } else if (data?.id) {
            fetchToilDetails(data.id);
          }
        } else {
          cogoToast.error(responseData.message);
        }
      } else {
        cogoToast.error(res.data.message, {});
      }
    })
    .catch((err) => {
      setIsLoading(false);
      setIsSubmittingApproval(false);
      cogoToast.error(err.toString(), {});
      console.log(err);
    });
};

const handleModalApprove = () => {
  if (!pendingApprovalLevel) return;
  approve_toil(pendingApprovalLevel, 10001, approvalComments, true);
};

const handleModalReject = () => {
  if (!pendingApprovalLevel) return;
  approve_toil(pendingApprovalLevel, 10002, approvalComments, true);
};

const handleViewDetails = () => {
  setApprovalModalDismissed(true);
  setShowApprovalModal(false);
};

const openApprovalModal = () => {
  if (pendingApprovalLevel) {
    setShowApprovalModal(true);
  }
};

const closeApprovalModal = () => {
  if (isSubmittingApproval) return;
  setApprovalModalDismissed(true);
  setShowApprovalModal(false);
};

 
const listLeaveTypes=async ()=>{
  setIsLoading(true);
  setLeave_types(await getList(ENDPOINTS.LEAVE_TYPES));
  setIsLoading(false);
} 



const PrintLeave = () => {
 
  var printContents = document.getElementById("print");

  let w = 600;
  let h = 700;

  var left = window.screen.width / 2 - w / 2;
  var top = window.screen.height / 2 - h / 2;
  var docprint = window.open(
    "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
      w +
      ", height=" +
      h +
      ", top=" +
      top +
      ", left=" +
      left
  );

  docprint.document.open();
  docprint.document.write(`<head><style>
  table{
    border-collapse:collapse !important;
  }
  table {
    width: 95% !important;
    margin: auto !important;
  }
   
   td {
    border: 1px solid rgba(200, 198, 198, 0.452);
    text-align: left;
    border: 1px solid gray;
    padding: 5px !important;
    color: #000000 !important;
  }</style></head>   `);

  docprint.document.write(printContents.innerHTML);
 
 


  setTimeout(() => {

    docprint.print();
  }, 700);
  setTimeout(() => {

    docprint.close();
  }, 900);

  return;


 
//window.print("a4_invoice");
};
 
const getMinDate=()=>{
  try{
  var date = new Date();
 

 

return  date.setDate(date.getDate() - 1) ;
  }catch(e){alert(e)}
//.addDays(-1);
 
}

const handleDateChange = (dates) => {
   
    
    setSelectedDates(dates);
  };
  return (
    <div className="page-wrapper" style={{width:"90%",margin:"auto"}}>

      {isLoadingDetails ? (
        <div className="text-center py-5">
          <Spinner color="primary" />
          <div className="text-muted mt-2">Loading TOIL request...</div>
        </div>
      ) : !data ? (
        <div className="text-center py-5 text-muted">TOIL request not found.</div>
      ) : (
        <>
        <div className="page-body">
          <div className="container-xl">
            <div className="card">
            
             
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h1 className="mb-0">Toil Detail</h1>
                <div className="d-flex flex-wrap gap-2">
                  {pendingApprovalLevel && !showApprovalModal ? (
                    <button type="button" onClick={openApprovalModal} className="btn btn-warning">
                      Review &amp; Approve
                    </button>
                  ) : null}
                  <button onClick={() => PrintLeave()} className="btn btn-primary">
                    <FaPrint /> &nbsp;&nbsp; Print
                  </button>
                </div>
              </div>
                  
                   
               
                  <div className="card-body" id="print">
                  {pendingApprovalLevel && !showApprovalModal ? (
                    <div
                      className="mb-4 p-3 rounded border"
                      style={{ background: "#fffbeb", borderColor: "#fcd34d" }}
                    >
                      <div className="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-2">
                        <div>
                          <h5 className="mb-1" style={{ color: "#92400e", fontWeight: 700 }}>
                            Pending your approval
                          </h5>
                          <div style={{ fontSize: "0.88rem", color: "#78350f" }}>
                            Review the TOIL details below, then approve or reject (Level {pendingApprovalLevel}).
                          </div>
                        </div>
                        
                      </div>
                      <FormGroup className="mb-3">
                        <Label for="pageApprovalComment">Comment</Label>
                        <Input
                          id="pageApprovalComment"
                          type="textarea"
                          rows={3}
                          value={approvalComments}
                          onChange={(e) => setapprovalComments(e.target.value)}
                          placeholder="Add your comment..."
                          disabled={isSubmittingApproval}
                        />
                      </FormGroup>
                      <div className="d-flex flex-wrap gap-2">
                        <Button
                          color="success"
                          onClick={handleModalApprove}
                          disabled={isSubmittingApproval}
                        >
                          Approve
                        </Button>
                        <Button
                          color="danger"
                          onClick={handleModalReject}
                          disabled={isSubmittingApproval}
                        >
                          Reject
                        </Button>
                      </div>
                    </div>
                  ) : null}
                  <center>
               
                  <img
              src="/images/logo.jpg"
              id="icon" 
            /> 
                  <h1> ISLAMIC RELIEF </h1>
                  <hr/>
                  <h1> TOIL FORM </h1>
                  
                </center>
                  {/* <div className="input-group">

                                <input type="text"   styles={{width:"200px"}} onChange={(e)=>setstaff_code(e.target.value)} className="form-control" placeholder='SOM XXXX'/>
                                
                              </div> */}

<hr/>
<table className="info_table" >


<tr>
  <td className="blue-bg">STAFF ID</td> <td>{data?.staff?.staff_id} </td>
  <td className="blue-bg">Staff Name </td> <td> {data?.staff?.staff_name}</td>
  
  </tr>
  <tr>
  <td className="blue-bg">Email Address</td> <td> {data?.staff?.email}</td>
  <td className="blue-bg"> Request Date </td>  <td>{data?.created_at} </td>
  
  </tr>
  <tr>
  <td className="blue-bg">Subject </td> <td> {data?.subject}</td>

  <td className="blue-bg">Description </td> <td> {data?.description}</td>
  </tr>
  <tr>
  <td className="blue-bg">Toil Days </td> <td>
     {toilDates.map((d, index) => (
    <li key={`${d}-${index}`}>{d}</li>
  ))}</td>
  <td className="blue-bg">Number of Days </td> <td> {data?.total_toil_days}</td>
  </tr>

  
 
</table>
<br/><br/>
 <h1> Toil Request Approval</h1>

 <table className="info_table">
  <thead>
    <tr>
      <th>Toil Approval Level</th>
      <th>Status</th>
      <th>Comments</th>
      <th>Acted On.</th>
    </tr>
  </thead>
  <tbody>
    {requestApprovers.map((approver) => {
      const canAct =
        approver.status == PENDING_STATUS &&
        isCurrentUserApprover({ id: approver.id }, currentUser);
      return (
        <tr key={`request-approver-${approver.level}`}>
          <td>
            <b>{formatDisplayValue(approver.name)}</b>
            <br />
            {formatDisplayValue(approver.role)}
            {approver.staffId ? (
              <>
                <br />
                <span className="text-muted" style={{ fontSize: "0.85rem" }}>
                  {approver.staffId}
                </span>
              </>
            ) : null}
            {approver.email ? (
              <>
                <br />
                <span className="text-muted" style={{ fontSize: "0.85rem" }}>
                  {approver.email}
                </span>
              </>
            ) : null}
          </td>
          <td>
            {renderApprovalStatus(approver.status)}
            {canAct ? (
              <>
                <br />
                <input
                  type="text"
                  className="form-control mt-2"
                  onChange={(e) => setapprovalComments(e.target.value)}
                  placeholder="Comment before approve/reject"
                />
                <div className="mt-2">
                  <Badge
                    className="badge bg-green me-2"
                    onClick={() => approve_toil(approver.level, 10001, approvalComments)}
                  >
                    Approve
                  </Badge>
                  <Badge
                    className="badge bg-red"
                    onClick={() => approve_toil(approver.level, 10002, approvalComments)}
                  >
                    Reject
                  </Badge>
                </div>
              </>
            ) : null}
          </td>
          <td>{formatDisplayValue(approver.remarks)}</td>
          <td>{formatDisplayValue(approver.actedOn)}</td>
        </tr>
      );
    })}
  </tbody>
 </table>



<br/><br/>
 

{data?.request_approver_1_status==10001 && data?.request_approver_2_status==10001 && 
<>
 <h1> Fill Claim Form</h1>
 {claimSubmitted && (
   <div className="alert alert-success" role="alert">
     <FaCheckCircle className="me-2" />
     Claim form submitted successfully. Your responses are shown below.
   </div>
 )}
 <Survey
   model={survey_Model}
   onCompleting={(sender, options) => {
     options.allowComplete = false;
     claimToilRequest(sender);
   }}
 />
 </>
}

 {data?.claim_date && 

<table className="info_table">
  <thead>
    <th>Claim Approval Level</th>
    <th>Status</th>
    <th>Comments</th>
    <th>Acted On.</th>

  </thead>


  <tr>
<td><b> {data?.claim_approver_1?.staff_name}  
  
  
  
  </b> <br/>
{data?.claim_approver_1?.role} </td>
<td>
{ data?.claim_approver_1_status==10000?<span><FaExclamationCircle style={{color:"grey"}}></FaExclamationCircle> &nbsp;Pending  
<br/> 
</span>:
 data?.claim_approver_1_status==10002? <span><FaTimesCircle style={{color:"red"}}></FaTimesCircle> &nbsp; Rejected </span> :
 <div> <FaCheckCircle style={{color:"green"}}></FaCheckCircle> Approved </div>
}
 

</td>
<td>{data?.claim_approver_1_remarks}</td>
<td>{data?.claim_approver_1_date}</td>


  </tr>
 

  <tr>
<td><b> {data?.claim_approver_2?.staff_name}  
  
  
  
  </b> <br/>
{data?.claim_approver_2?.role} </td>
<td>
{ data?.claim_approver_2_status==10000?<span><FaExclamationCircle style={{color:"grey"}}></FaExclamationCircle> &nbsp;Pending  
<br/> 
</span>:
 data?.claim_approver_2_status==10002? <span><FaTimesCircle style={{color:"red"}}></FaTimesCircle> &nbsp; Rejected </span> :
 <div> <FaCheckCircle style={{color:"green"}}></FaCheckCircle> Approved </div>
}
 

</td>
<td>{data?.claim_approver_2_remarks}</td>
<td>{data?.claim_approver_2_date}</td>


  </tr>

 </table>



}
 

 










 

                  </div>
  
 
 
                   
           
              </div>
            </div>
          </div>
       
      <Modal isOpen={showApprovalModal} toggle={closeApprovalModal} centered>
        <ModalHeader toggle={closeApprovalModal}>TOIL Request Approval</ModalHeader>
        <ModalBody>
          <p className="mb-3" style={{ fontSize: "0.9rem", color: "#475569" }}>
            You have a pending TOIL approval for{" "}
            <strong>{data?.staff?.staff_name || "this staff member"}</strong>
            {pendingApprovalLevel ? ` (Approver level ${pendingApprovalLevel})` : ""}.
          </p>
          <p className="mb-3 text-muted" style={{ fontSize: "0.85rem" }}>
            Add a comment and approve or reject now, or view the full details on the page first.
          </p>
          <FormGroup>
            <Label for="toilApprovalComment">Comment</Label>
            <Input
              id="toilApprovalComment"
              type="textarea"
              rows={4}
              value={approvalComments}
              onChange={(e) => setapprovalComments(e.target.value)}
              placeholder="Add your comment..."
              disabled={isSubmittingApproval}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter className="d-flex flex-wrap gap-2 justify-content-between">
          <Button color="info" outline onClick={handleViewDetails} disabled={isSubmittingApproval}>
            <FaEye className="me-1" />
            View Details
          </Button>
          <div className="d-flex flex-wrap gap-2">
            <Button color="secondary" onClick={closeApprovalModal} disabled={isSubmittingApproval}>
              Cancel
            </Button>
            <Button
              color="danger"
              onClick={handleModalReject}
              disabled={isSubmittingApproval || !pendingApprovalLevel}
            >
              {isSubmittingApproval ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Processing...
                </>
              ) : (
                "Reject"
              )}
            </Button>
            <Button color="success" onClick={handleModalApprove} disabled={isSubmittingApproval || !pendingApprovalLevel}>
              {isSubmittingApproval ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Processing...
                </>
              ) : (
                "Approve"
              )}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
        </>
      )}
    </div>
  );
}

export default ToilDetails